import { render } from "./twelve-footer.vue?vue&type=template&id=7cdcac68"
import script from "./twelve-footer.vue?vue&type=script&lang=js"
export * from "./twelve-footer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__